import ExternalLink from '../single/externalLink';

const Understandable = () => {
	return (
		<>
		<h2 id="understandable">Principio 3. <ExternalLink href="https://www.w3.org/TR/WCAG21/#understandable" contents="Comprensible" /></h2>
		<blockquote>
		<p>La información y el manejo de la interfaz de usuario deben ser comprensibles.</p>
		</blockquote>
		</>
	)
}

export default Understandable;
